// extracted by mini-css-extract-plugin
export default {"message":"_3_hi2","countdown":"_34hU5","countdown-value":"_244go","countdownValue":"_244go","countdown-ended":"_3NBk2","countdownEnded":"_3NBk2"};